import React, { useState } from "react";
import { Buttons, Inputs } from "components";

// ใช้ร่วมกันทั้ง ปฏิเสธ / ยกเลิก (บังคับเหตุผล) และ กันที่นั่ง / ย้อนกลับ (ไม่บังคับ)
const ReasonModal = ({ title, label, required, confirmLabel = "ยืนยัน", onClose, onConfirm }) => {
  const [_reason, _setReason] = useState("");
  const [_error, _setError] = useState();

  const _handleConfirm = () => {
    if (required && !_reason.trim()) {
      _setError("กรุณาระบุเหตุผล");
      return;
    }
    onConfirm(_reason.trim());
  };

  return (
    <div className="modal_card">
      <div className="modal_title">{title}</div>
      <div className="modal_row">
        <div className="m_label">{label}</div>
        <Inputs.TextArea
          rows={4}
          value={_reason}
          errors={_error}
          onChange={(e) => {
            _setReason(e.target.value);
            _setError();
          }}
        />
      </div>
      <div className="modal_btns">
        <div className="w120">
          <Buttons.BgStandard theme_gray label="ปิด" onClick={onClose} />
        </div>
        <div className="w140">
          <Buttons.BgStandard theme_purple label={confirmLabel} onClick={_handleConfirm} />
        </div>
      </div>
    </div>
  );
};

export default ReasonModal;
